import React, { useEffect } from 'react';
import styles from './ConfirmationModal.module.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, children }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={`${styles.overlay} ${isOpen ? styles.overlayVisible : ''}`}>
      <div className={`${styles.modal} ${isOpen ? styles.modalVisible : ''}`}>
        <h2>{title}</h2>
        <p>{children}</p>
        <div className={styles.buttons}>
          <button onClick={onConfirm} className={styles.confirmButton}>
            Confirmer
          </button>
          <button onClick={onClose} className={styles.cancelButton}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
